export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-accent-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-50/20 text-background-50 mb-6">
            <i className="ri-mail-send-line text-3xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-accent-100 leading-relaxed mb-8 max-w-lg mx-auto">
            你有独家爆料或内幕消息？欢迎投稿！编辑团队会认真审核每一条来稿，优质爆料优先发布并注明来源。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-accent-600 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              投稿爆料
            </a>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/30 text-background-50 hover:bg-background-50/10 font-medium rounded-md text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-smile-2-line text-lg"></i>
              商务合作
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}